import React from "react";

const Projectkharah = () => {
  return (
    <div>
      <p>Details </p>
    </div>
  );
};

export default Projectkharah;
